































import { defineComponent, PropType, computed } from '@vue/composition-api';
import { Carousel, Slide } from '@fc/angie-ui';
import FCImage from '~/components/FCImage.vue';

interface ISlideData {
  title: string;
  ctaLink: {
    cached_url: string;
  },
  image: {
    filename: string;
    alt: string;
  }
}

export default defineComponent({
  name: 'MobileDrawerCarousel',
  props: {
    carouselData: {
      type: Array as PropType<ISlideData[]>,
      required: true,
      default: () => [],
    },
  },
  components: {
    Carousel,
    Slide,
    FCImage,
  },
  setup(props) {
    return {
      isValid: computed(() => props.carouselData.length > 0),
    };
  },
});
